export { default } from './About'



// WEBPACK FOOTER //
// ./src/components/About/index.ts